// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/drag.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/drag/drag.js';
import g1 from '../lessons/aeronautics/drag/lift-drag-ratio-and-speeds.js';

mount([g0, g1]);
